import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Game from './components/Game.vue'
import DisableTracking from './components/DisableTracking.vue'
import EnableTracking from './components/EnableTracking.vue'
import './index.css'
import { createHead } from "@unhead/vue/client"
import { loadGameConfig } from './config'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Game
    },
    {
      path: '/internal/disable-tracking',
      component: DisableTracking
    },
    {
      path: '/internal/enable-tracking',
      component: EnableTracking
    }
  ]
})

// Load game config from backend, then mount app
loadGameConfig().then(() => {
  const app = createApp(App)
  const unhead = createHead()
  app.use(router)
  app.use(unhead)
  app.mount('#app')
})
